<template>
    <div>
      <vue-good-table mode="remote" @on-page-change="onPageChange" @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange" :totalRows="table.total_records"
        :isLoading.sync="table.isLoading" :pagination-options="{
            enabled: true,
            dropdownAllowAll: false,
            perPageDropdown: [10, 25, 50, 100],
          }" :columns="table.columns" :rows="table.rows">
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'action'">
            <a v-on:click="editAccount(props.row)" class="btn btn-primary text-white margin5">Edit</a>
            <a v-on:click="deleteAccount(props.row.id)" class="btn btn-danger text-white margin5">
              Hapus
            </a>
          </span>
          <span v-else-if="props.column.field == 'active'">
            <span v-if="props.row.active == 1" class="badge badge-success">Aktif</span>
            <span v-else class="badge badge-danger">Tidak Aktif</span>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                table: {
                    total_records: 0,
                    isLoading: true,
                    columns: [{
                        label: "Bank",
                        field: "bank",
                        filterOptions: {
                            enabled: true,
                        },
                        sortable: false,
                    },
                    {
                        label: "No. Rekening",
                        field: "number",
                        filterOptions: {
                            enabled: true,
                        },
                        sortable: false,
                    },
                    {
                        label: "Atas Nama",
                        field: "name",
                        filterOptions: {
                            enabled: true,
                        },
                        sortable: false,
                    },
                    {
                        label: "Status",
                        field: "active",
                        filterOptions: {
                            enabled: true,
                        },
                        sortable: false,
                    },
                    {
                        label: "Action",
                        field: "action",
                        sortable: false,
                    },
                    ],
                    rows: [],
                    params: {
                        page: 1,
                        limit: 10,
                        columnFilters: {},
                    },
                },
            };
        },
        beforeDestroy() {
            this.$root.$off("refresh_table", this.fnRefreshTable);
        },
        mounted() {
            this.fnRefreshTable = () => {
                this.loadData();
            }
            this.$root.$on("refresh_table", this.fnRefreshTable);
            this.loadData();
        },
        methods: {
            async loadData() {
                this.table.isLoading = true;
                try {
                    let response = await this.$store.dispatch('admin_bank_accounts_list', this.table.params);
                    this.table.rows = response.data.data.bank_accounts || [];
                    this.table.total_records = this.table.rows.length;
                } catch (err) {
                    this.$toast.error(err.response?.data?.message || "Gagal memuat rekening bank");
                } finally {
                    this.table.isLoading = false;
                }
            },
            editAccount(row) {
                this.$root.$emit("edit_bank_account", row);
            },
            async deleteAccount(id) {
                if (confirm("Yakin ingin menghapus rekening ini?")) {
                    try {
                        let response = await this.$store.dispatch('admin_bank_account_delete', { id: id });
                        this.$toast.success(response.data.message);
                        this.$root.$emit("refresh_table", true);
                    } catch (err) {
                        this.$toast.error(err.response?.data?.message || "Gagal menghapus rekening");
                    }
                }
            },
            onPageChange(params) {
                this.table.params.page = params.currentPage;
                this.loadData();
            },
            onPerPageChange(params) {
                this.table.params.limit = params.currentPerPage;
                this.loadData();
            },
            onSortChange() {},
            onColumnFilter(params) {
                this.table.params.columnFilters = params;
                this.loadData();
            },
        },
    };
</script>

<style scoped>

</style>
